import { SelectOption } from '@/components/common/SelectDropdown';

export const currencies: SelectOption[] = [
  { label: 'INR', value: 'INR' },
  { label: 'USD', value: 'USD' },
  { label: 'EUR', value: 'EUR' },
];

export const states: SelectOption[] = [
  { label: '[GJ] - Gujarat (24)', value: '24' },
  { label: '[MH] - Maharashtra (27)', value: '27' },
  { label: '[DL] - Delhi (07)', value: '07' },
  { label: '[KA] - Karnataka (29)', value: '29' },
  { label: '[TN] - Tamil Nadu (33)', value: '33' },
  { label: '[UP] - Uttar Pradesh (09)', value: '09' },
  { label: '[RJ] - Rajasthan (08)', value: '08' },
  { label: '[WB] - West Bengal (19)', value: '19' },
  { label: '[HR] - Haryana (06)', value: '06' },
  { label: '[PB] - Punjab (03)', value: '03' },
  { label: '[AP] - Andhra Pradesh (37)', value: '37' },
  { label: '[TS] - Telangana (36)', value: '36' },
  { label: '[KL] - Kerala (32)', value: '32' },
  { label: '[OR] - Odisha (21)', value: '21' },
  { label: '[JH] - Jharkhand (20)', value: '20' },
  { label: '[AS] - Assam (18)', value: '18' },
  { label: '[BR] - Bihar (10)', value: '10' },
  { label: '[CG] - Chhattisgarh (22)', value: '22' },
  { label: '[HP] - Himachal Pradesh (02)', value: '02' },
  { label: '[UK] - Uttarakhand (05)', value: '05' },
  { label: '[GA] - Goa (30)', value: '30' },
  { label: '[MN] - Manipur (14)', value: '14' },
  { label: '[ML] - Meghalaya (17)', value: '17' },
  { label: '[MZ] - Mizoram (15)', value: '15' },
  { label: '[NL] - Nagaland (13)', value: '13' },
  { label: '[SK] - Sikkim (11)', value: '11' },
  { label: '[TR] - Tripura (16)', value: '16' },
  { label: '[AR] - Arunachal Pradesh (12)', value: '12' },
  { label: '[JK] - Jammu and Kashmir (01)', value: '01' },
  { label: '[LA] - Ladakh (38)', value: '38' },
  { label: '[AN] - Andaman and Nicobar Islands (35)', value: '35' },
  { label: '[CH] - Chandigarh (04)', value: '04' },
  { label: '[DN] - Dadra and Nagar Haveli and Daman and Diu (26)', value: '26' },
  { label: '[LD] - Lakshadweep (31)', value: '31' },
  { label: '[PY] - Puducherry (34)', value: '34' },
];

export const taxPreferences = [
  { value: 'taxable', label: 'Taxable' },
  { value: 'non-taxable', label: 'Non-Taxable' },
  { value: 'non-gst-supply', label: 'Non-GST Supply' },
  { value: 'out-of-scope', label: 'Out of Scope' },
];

export const getTaxPreferenceLabel = (value: string) => {
  return taxPreferences.find((opt) => opt.value === value)?.label || value;
};

export const getCurrencyLabel = (currency: string) => {
  return currencies.find((c) => c.value === currency)?.label;
};

export const getStatesLabel = (state: string) => {
  return states.find((s) => s.value === state)?.label;
};

export const DEFAULT_PAGINATION = {
  total: 0,
  limit: 0,
  page: 0,
  pages: 0,
} as const;
